import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { School, CheckCircle2 } from "lucide-react";

export default function Register() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ school_name: "", name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", f);
      setSession(data.access_token, data.user);
      nav("/");
    } catch (ex) {
      setErr(apiError(ex, "Kayıt başarısız"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="relative z-10 flex items-center gap-3">
          <img src="/logo192.png" alt="Logo" className="h-11 w-11 rounded-xl object-cover bg-white/15" />
          <span className="text-lg font-bold tracking-tight">HAFTALIK KTT</span>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight">Kurumunuzu kaydedin,<br />7 gün ücretsiz deneyin</h1>
          <ul className="space-y-3 text-primary-foreground/90">
            {["Sınırsız sınav, öğrenci ve optik form", "QR'lı optik okuma, otomatik puanlama", "Sınıf & öğrenci analizi, karne ve veli e-postası", "Kurum verileriniz tamamen size özel ve izole"].map((t) => (
              <li key={t} className="flex items-center gap-2"><CheckCircle2 className="h-5 w-5 shrink-0" />{t}</li>
            ))}
          </ul>
          <div className="flex gap-4 pt-2">
            <div className="rounded-xl bg-white/10 px-5 py-3"><div className="text-2xl font-extrabold">1.500 ₺</div><div className="text-xs opacity-80">aylık</div></div>
            <div className="rounded-xl bg-white/10 px-5 py-3"><div className="text-2xl font-extrabold">18.000 ₺</div><div className="text-xs opacity-80">yıllık</div></div>
          </div>
        </div>
        <div className="relative z-10 text-xs text-primary-foreground/60">© 2026 Haftalık KTT</div>
        <div className="absolute -right-24 -bottom-24 h-96 w-96 rounded-full bg-white/5" />
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="register-form">
          <div className="flex items-center gap-2 mb-2"><School className="h-6 w-6 text-primary" /><h2 className="text-2xl font-bold tracking-tight">Kurum Kaydı</h2></div>
          <p className="text-sm text-muted-foreground">7 günlük ücretsiz deneme hemen başlar. Kredi kartı gerekmez.</p>
          <div className="space-y-2"><Label htmlFor="school">Okul / Kurum Adı</Label><Input id="school" value={f.school_name} onChange={set("school_name")} required data-testid="register-school" placeholder="Örn. Atatürk Ortaokulu" /></div>
          <div className="space-y-2"><Label htmlFor="name">Yetkili Ad Soyad</Label><Input id="name" value={f.name} onChange={set("name")} required data-testid="register-name" /></div>
          <div className="space-y-2"><Label htmlFor="email">E-posta</Label><Input id="email" type="email" value={f.email} onChange={set("email")} required data-testid="register-email" /></div>
          <div className="space-y-2"><Label htmlFor="password">Şifre</Label><Input id="password" type="password" value={f.password} onChange={set("password")} required minLength={6} data-testid="register-password" placeholder="En az 6 karakter" /></div>
          {err && <div className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2" data-testid="register-error">{err}</div>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit">{loading ? "Kaydediliyor..." : "Ücretsiz Denemeyi Başlat"}</Button>
          <p className="text-sm text-center text-muted-foreground">Zaten hesabınız var mı? <Link to="/giris" className="text-primary font-semibold" data-testid="register-login-link">Giriş yapın</Link></p>
        </form>
      </div>
    </div>
  );
}
